import { FC } from "react";
import s from "./style.module.css";

export const Subtitle: FC<{ label: string }> = ({ label }) => {
  return <h3 className={s.subtitle}>{label}</h3>;
};
